import React, { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import Navbar from '@/components/public/Navbar';
import Hero from '@/components/public/Hero';
import About from '@/components/public/About';
import Services from '@/components/public/Services';
import CommunityBanner from '@/components/public/Why';
import Marquee from '@/components/public/Marquee';
import Contact from '@/components/public/Contact';
import Footer from '@/components/public/Footer';
import SeoHead from '@/components/public/SeoHead';
import BookingDialog from '@/components/public/BookingDialog';
import { DEFAULT_SITE_CONTENT, mergeContent } from '@/constants/defaultSiteContent';
import { logger } from '@/lib/logger';
import { initTracker } from '@/lib/tracker';
import { getToken } from '@/lib/tokenStore';

export default function PublicHome() {
  const [siteContent, setSiteContent] = useState(DEFAULT_SITE_CONTENT);
  const [brand, setBrand] = useState(null);
  const [seo, setSeo] = useState(null);
  const [bookingOpen, setBookingOpen] = useState(false);

  useEffect(() => {
    document.documentElement.classList.remove('dark');
    initTracker();

    const searchParams = new URLSearchParams(window.location.search);
    const isPreview = searchParams.get('preview') === 'draft';

    (async () => {
      // Legacy brand/seo (still supported)
      try {
        const { data } = await api.get('/public/content');
        setBrand(data?.brand?.extra || null);
        setSeo(data?.seo?.extra || null);
      } catch (err) {
        logger.warn('Failed to load public content', err);
      }

      // New unified site content
      try {
        if (isPreview && getToken()) {
          const { data } = await api.get('/admin/site-content');
          setSiteContent(mergeContent(DEFAULT_SITE_CONTENT, data?.draft || {}));
        } else {
          const { data } = await api.get('/public/site-content');
          setSiteContent(mergeContent(DEFAULT_SITE_CONTENT, data || {}));
        }
      } catch (err) {
        logger.warn('Falling back to defaults for site content', err);
      }
    })();
  }, []);

  return (
    <div className="min-h-screen bg-[#F5F0E6] text-[#141414]" style={{ fontFamily: "'Figtree', system-ui, sans-serif" }}>
      <SeoHead seo={seo} brand={brand ? { extra: brand } : null} />
      <Navbar brand={brand} content={siteContent.navbar} />
      <Hero onCta={() => setBookingOpen(true)} content={siteContent.hero} />
      <Marquee content={siteContent.marquee} />
      <About content={siteContent.about} />
      <Services content={siteContent.services} />
      <CommunityBanner content={siteContent.community} />
      <Contact />
      <Footer content={siteContent.footer} brand={brand} onCta={() => setBookingOpen(true)} />
      <BookingDialog open={bookingOpen} onClose={() => setBookingOpen(false)} service={{ title: 'General Booking' }} />
    </div>
  );
}
